<template>
	<!-- <div class="sf-account login"> -->
	<div class="sf-account-containter w-100 h-100">
		<div class="row no-gutters h-100 w-100">
			<div class="col-lg-8">
				<div class="sf-account-text hd_head-100_1" v-html="text"></div>
			</div>
			<div class="col-lg-4 sf-account-right">
				<login-form />
			</div>
		</div>
	</div>
	<!-- </div> -->
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import LoginForm from './Content/LoginForm.vue';

export default {
	components: { LoginForm },
	computed: {
		...rootComputed,

		text() {
			return process.env.VUE_APP_LOGIN_PAGE_TEXT;
		}
	},

	created() {
		this.setInitStore_();
	},

	methods: {
		...rootMethods
	}
};
</script>
<style></style>
